
let urls = document.querySelectorAll(`a`);

if (urls.length) {
    urls.forEach((item) => {
        if (window.location.href === item.href) {
            if (!item.href.includes("#")) {
                item.removeAttribute("href");
                item.setAttribute("href", "#");
            }
        }
    });
}